import useRequest from "./useRequest";

//const PRODUCT_API_URL = "http://20.123.82.238:5000/Product/";
// const PRODUCT_API_URL = "https://03ed-40-113-34-8.ngrok-free.app/Product"
const PRODUCT_API_URL = "https://decdoutmerch.com/spector/product"

export function useGetProductService() {
    return useRequest({ url: PRODUCT_API_URL, onMount: true });
}
